"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultInvitationType = exports.getInvitationTypeState = exports.getInvitationTypeErrors = exports.getIsInvitationTypesSaved = exports.getIsInvitationTypesSaving = exports.getIsInvitationTypesLoaded = exports.getIsInvitationTypesLoading = exports.getIsInvitationTypeRequiresAddress = exports.getMessageTextLimit = exports.getSelectedInvitationTypeContactAddress = exports.getSelectedInvitationTypeImage = exports.getSelectedInvitationTypeName = exports.getSelectedInvitationTypeId = exports.getIsSelectedDirectMailInvitationType = exports.getIsSelectedLinkInvitationType = exports.getIsSelectedEmailInvitationType = exports.getSelectedInvitationType = exports.getAvailableInvitationTypes = void 0;

var _reselect = require("reselect");

var _ramda = require("ramda");

var _invitationType = require("./invitationType.constants");

var _invitationType2 = require("./invitationType.types");

var getInvitationTypesState = function getInvitationTypesState(state) {
  return state.createGift.invitationType;
};

var getAvailableInvitationTypes = (0, _reselect.createSelector)(getInvitationTypesState, function (state) {
  return state.availableInvitationTypes;
});
exports.getAvailableInvitationTypes = getAvailableInvitationTypes;
var getSelectedInvitationType = (0, _reselect.createSelector)(getInvitationTypesState, function (state) {
  return state.selectedInvitationType;
});
exports.getSelectedInvitationType = getSelectedInvitationType;
var getIsSelectedEmailInvitationType = (0, _ramda.pipe)(getSelectedInvitationType, function (invitationType) {
  return (invitationType === null || invitationType === void 0 ? void 0 : invitationType.id) === _invitationType2.VirtualGiftInvitationMethod.email;
});
exports.getIsSelectedEmailInvitationType = getIsSelectedEmailInvitationType;
var getIsSelectedLinkInvitationType = (0, _ramda.pipe)(getSelectedInvitationType, function (invitationType) {
  return (invitationType === null || invitationType === void 0 ? void 0 : invitationType.id) === _invitationType2.VirtualGiftInvitationMethod.link;
});
exports.getIsSelectedLinkInvitationType = getIsSelectedLinkInvitationType;
var getIsSelectedDirectMailInvitationType = (0, _ramda.pipe)(getSelectedInvitationType, function (invitationType) {
  return (invitationType === null || invitationType === void 0 ? void 0 : invitationType.id) === _invitationType2.VirtualGiftInvitationMethod.direct;
});
exports.getIsSelectedDirectMailInvitationType = getIsSelectedDirectMailInvitationType;
var getSelectedInvitationTypeId = (0, _ramda.pipe)(getSelectedInvitationType, function (selectedType) {
  return selectedType === null || selectedType === void 0 ? void 0 : selectedType.id;
});
exports.getSelectedInvitationTypeId = getSelectedInvitationTypeId;
var getSelectedInvitationTypeName = (0, _ramda.pipe)(getSelectedInvitationType, (0, _ramda.propOr)('', 'name'));
exports.getSelectedInvitationTypeName = getSelectedInvitationTypeName;
var getSelectedInvitationTypeImage = (0, _ramda.pipe)(getSelectedInvitationType, (0, _ramda.propOr)('', 'image'));
exports.getSelectedInvitationTypeImage = getSelectedInvitationTypeImage;
var getSelectedInvitationTypeContactAddress = (0, _ramda.pipe)(getSelectedInvitationType, (0, _ramda.propOr)('', 'contactAddress'));
exports.getSelectedInvitationTypeContactAddress = getSelectedInvitationTypeContactAddress;
var getMessageTextLimit = (0, _ramda.pipe)(getSelectedInvitationType, (0, _ramda.propOr)(_invitationType.DEFAULT_TEXT_CHARS_LIMIT, 'messageTextLimit'));
exports.getMessageTextLimit = getMessageTextLimit;
var getIsInvitationTypeRequiresAddress = (0, _ramda.pipe)(getSelectedInvitationType, (0, _ramda.propOr)(false, 'isAddressRequired'));
exports.getIsInvitationTypeRequiresAddress = getIsInvitationTypeRequiresAddress;
var getIsInvitationTypesLoading = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('isLoading'));
exports.getIsInvitationTypesLoading = getIsInvitationTypesLoading;
var getIsInvitationTypesLoaded = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('isLoaded'));
exports.getIsInvitationTypesLoaded = getIsInvitationTypesLoaded;
var getIsInvitationTypesSaving = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('isSaving'));
exports.getIsInvitationTypesSaving = getIsInvitationTypesSaving;
var getIsInvitationTypesSaved = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('isSaved'));
exports.getIsInvitationTypesSaved = getIsInvitationTypesSaved;
var getInvitationTypeErrors = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('errors'));
exports.getInvitationTypeErrors = getInvitationTypeErrors;
var getInvitationTypeState = (0, _ramda.pipe)(getInvitationTypesState, (0, _ramda.prop)('state'));
exports.getInvitationTypeState = getInvitationTypeState;
var getDefaultInvitationType = (0, _reselect.createSelector)(getAvailableInvitationTypes, function (types) {
  if (types.length === 1) {
    return types[0];
  }

  var emailInvitationType = types.find(function (item) {
    return item.id === _invitationType2.VirtualGiftInvitationMethod.email;
  });
  return emailInvitationType || types.find(function (item) {
    return item.id !== _invitationType2.VirtualGiftInvitationMethod.link;
  });
});
exports.getDefaultInvitationType = getDefaultInvitationType;